export default "__VITE_ASSET__CX5C_xyK__"